<template>
    <div ref="cv" class="column-visibility" @keyup.escape="show = false">
        <button @click="show = !show"><font-awesome-icon icon="table-list" rotation="90" fixed-width title="Show, hide, and reorder columns" /></button>
        <div v-if="show" class="column-visibility-list" title="Drag to reorder columns">
            <div class="form-layout">
                <div v-for="(column, index) in columns"
                draggable
                @dragstart="columnDrag($event, column.key)"
                @drop="columnDrop($event, column.key)"
                @dragenter.prevent="columnDragEnter($event, column.key)" @dragover.prevent
                class="form-layout-item"
                >
                    <input :id="`visibility_option_${index}`" type="checkbox" @change="visibilityChanged(column)" :value="column.key" :checked="visible[column.key]"
                        :disabled="visible[column.key] && visibleCount === 1" :title="visible[column.key] ? 'Hide column' : 'Show column'">
                    <label :for="`visibility_option_${index}`">{{ column.label }}</label>
                    <font-awesome-icon icon="ellipsis-vertical" fixed-width></font-awesome-icon>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ColumnVisibility',
    props: {
        columns: Array,
        visible: Object,
    },
    data() {
        return {
            show: false,
        }
    },
    methods: {
        clickedSomewhere(event) {
            const withinThisComponent = event.composedPath().includes(this.$refs.cv);
            if (!withinThisComponent) {
                this.show = false;
            }
        },
        visibilityChanged(column) {
            this.$emit('visibleChanged', column,  !this.visible[column.key]);
        },
        columnDrag(event, keyFrom) {
            event.dataTransfer.dropEffect = 'move';
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData(JSON.stringify(keyFrom), '');
        },
        columnDragEnter(event, keyOver) {
            const keyFrom = JSON.parse(event.dataTransfer.types[0]);
            this.$emit('orderChanged', keyFrom, keyOver);
        },
        columnDrop(event, keyTo) {
            //
        },
    },
    computed: {
        visibleCount() {
            return Object.values(this.visible).filter(e => e).length;
        }
    },
    watch: {
        show: function() {
            if (this.show) {
                document.addEventListener('click', this.clickedSomewhere, { capture: true });
            }
            else {
                document.removeEventListener('click', this.clickedSomewhere, { capture: true });
            }
        }
    },
}
</script>
<style scoped>
.column-visibility button {
    border: 1px solid rgb(118, 118, 118);
    border-radius: 2px;
}
.column-visibility button:focus, .column-visibility input:focus, .column-visibility select:focus {
    outline: rgba(102, 179, 227, 0.75) auto 1px !important;
    outline-offset: 0px;
    z-index: 99;
}
.column-visibility-list {
    position: absolute;
    transform: translate(-230px, 0);
    width: 260px;
    max-height: 75vh;
    overflow-y: auto;
    padding: 16px;
    background-color: white;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
    border-radius: 2px;
    z-index: 999;
}
.form-layout {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.form-layout-item {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 15fr 1fr;
    column-gap: 9px;
}
.form-layout-item:hover {
    box-shadow: inset 0px 0px 0px 1px rgb(118, 118, 118, 0.25);
    cursor: move;
}
.form-layout-item label {
    color: rgb(37, 36, 34);
    font-size: 14px;
    margin-bottom: 0;
}
.form-layout-item input {
    font-size: 14px;
    height: 28px;
    padding-left: 3px;
    padding-right: 2px;
}
</style>
